import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const supportedLngs = ['en', 'es', 'de', 'ja', 'fr', 'pt', 'ru', 'it', 'nl', 'pl'];

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs,
    debug: false,
    interpolation: { escapeValue: false },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      order: ['path', 'localStorage', 'navigator'],
      lookupFromPathIndex: 0,
      caches: ['localStorage'],
    },
    ns: ['common', 'home', 'privacy', 'terms', 'workplace-policy', 'features', 'industries', 'comparisons', 'solutions', 'personas', 'pricing', 'about', 'contact', 'blog'],
    defaultNS: 'common',
  });

export { supportedLngs };
export default i18n;
